function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1, 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 5.5 1 C 4.6774686 1 4 1.6774686 4 2.5 L 4 3 L 2.5 3 C 1.1250151 3 0 4.1250151 0 5.5 L 0 14.5 A 0.50005 0.50005 0 0 0 0.5 15 L 14.5 15 A 0.50005 0.50005 0 0 0 15 14.5 L 15 5.5 C 15 4.1250151 13.874985 3 12.5 3 L 11 3 L 11 2.5 C 11 1.6774686 10.322531 1 9.5 1 L 5.5 1 z M 5.5 2 L 9.5 2 C 9.7814686 2 10 2.2185314 10 2.5 L 10 3 L 5 3 L 5 2.5 C 5 2.2185314 5.2185314 2 5.5 2 z M 2.5 4 L 12.5 4 C 13.335015 4 14 4.6649849 14 5.5 L 14 6 L 12 6 L 10 6 L 1.5 6 L 1 6 L 1 5.5 C 1 4.6649849 1.6649849 4 2.5 4 z M 1 7 L 1.5 7 L 3 7 L 3 8 L 5 8 L 5 7 L 10 7 L 10 8 L 12 8 L 12 7 L 14 7 L 14 14 L 1 14 L 1 7 z M 7 8 L 7 10 L 5 10 L 5 11 L 7 11 L 7 13 L 8 13 L 8 11 L 10 11 L 10 10 L 8 10 L 8 8 L 7 8 z"
}));

var SvgIcons8OrganTransplantation = function SvgIcons8OrganTransplantation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    viewBox: "0 0 16 16",
    width: "16px",
    height: "16px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcons8OrganTransplantation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons8-organ-transplantation.d91c1f07.svg";
export { ForwardRef as ReactComponent };